<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="我的球杆"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <!-- 添加新球杆按钮 -->
      <div class="add-club-btn-wrapper">
        <van-button
            class="add-club-btn"
            type="primary"
            size="large"
            icon="plus"
            @click="onAddClub"
        >
          添加新球杆
        </van-button>
      </div>

      <van-card
          shadow="never"
          class="my-card"
          v-for="club in clubList"
          :key="club.id">
        <template #desc>
          <!-- 序列号行 -->
          <div class="info-item serial-item">
            <div class="label-value-wrap">
              <span class="label">球杆编码:</span>
              <span class="value value_xlh">{{ club.value }}</span>
            </div>
            <!-- 状态标签 -->
            <van-tag class="bind-tag-red" v-if="club.bind ==='1'">待绑定</van-tag>
            <van-tag class="bind-tag-green" v-else-if="club.bind ==='2'">已绑定</van-tag>
            <van-tag class="bind-tag-green" v-else-if="club.bind ==='3'">绑定失败</van-tag>
            <van-tag class="bind-tag-red" v-else>{{ club.bind }}</van-tag>
          </div>

          <!-- 球杆信息 -->
          <div class="info-item">
            <span class="label">品牌:</span>
            <span class="value value_xlh">{{ club.brand }}</span>
          </div>
          <div class="info-item">
            <span class="label">系列:</span>
            <span class="value value_xlh">{{ club.model }}</span>
          </div>
          <div class="info-item">
            <span class="label">商品名称:</span>
            <span class="value value_xlh">{{ club.portalSpecs }}</span>
          </div>

          <!-- 操作按钮 -->
          <div class="info-item  serial-item">
            <div class="label-value-wrap">
              <span class="label">销售商户:</span>
              <span class="value value_xlh">{{ club.agentName }}</span>
            </div>
            <van-tag class="bind-tag" color="#D4AF37" text-color="#000" v-if="club.bind ==='1'"
                     @click="onBind(club.value )">去绑定
            </van-tag>
            <van-tag class="bind-tag" color="#D4AF37" text-color="#000" v-if="club.bind ==='3'"
                     @click="onBind(club.value )">重新绑定
            </van-tag>
            <van-tag class="bind-tag" color="#D4AF37" text-color="#000" v-if="club.bind ==='2'" @click="onUnBind(club)">
              解绑
            </van-tag>
          </div>
        </template>
      </van-card>
    </div>

    <!-- 解绑弹窗：优化高度和PC端适配 -->
    <van-dialog
        v-model="unbindDialogShow"
        title="解绑球杆"
        width="90%"
        :show-cancel-button="true"
        confirm-button-text="确认"
        cancel-button-text="取消"
        :before-close="handleBeforeClose"
        :close-on-click-overlay="false"
        class="unbind-dialog"
    >
      <!-- 球杆信息展示 -->
      <div class="unbind-info-wrap">
        <div class="unbind-info-item">
          <span class="unbind-label">球杆编码：</span>
          <span class="unbind-value">{{ currentClub.value }}</span>
        </div>
        <div class="unbind-info-item">
          <span class="unbind-label">品牌：</span>
          <span class="unbind-value">{{ currentClub.brand }}</span>
        </div>
        <div class="unbind-info-item">
          <span class="unbind-label">系列：</span>
          <span class="unbind-value">{{ currentClub.model }}</span>
        </div>
      </div>

      <!-- 解绑原因输入框 -->
      <van-field
          v-model="unbindReason"
          label="解绑原因"
          type="textarea"
          rows="4"
          required
          placeholder="请输入解绑原因"
      />
    </van-dialog>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {benefitsByUser, userUnbindByNumber} from "@/api/sales";
import {Dialog, Tag, Button, Toast} from "vant";

export default {
  components: {
    VanTag: Tag,
    VanButton: Button
  },
  data() {
    return {
      clubList: [],
      unbindDialogShow: false,  // 弹窗显示状态
      currentClub: {},          // 当前球杆信息
      unbindReason: ''          // 解绑原因
    }
  },
  created() {
    this.selectProductByUser();
  },
  methods: {
    // 添加新球杆
    onAddClub() {
      this.$router.push({path: '/app_activation'});
    },

    // 绑定球杆
    onBind(number) {
      this.$router.push({
        path: '/app_activation',
        query: {number: number}
      });
    },

    // 打开解绑弹窗
    onUnBind(club) {
      this.unbindReason = '';
      this.currentClub = {...club};
      this.unbindDialogShow = true;
    },

    // 核心：仅用 before-close 控制所有关闭逻辑（彻底解决转圈）
    async handleBeforeClose(action, done) {
      // 1. 点击取消按钮：直接关闭弹窗
      if (action === 'cancel') {
        done();
        return;
      }

      // 2. 点击确认按钮：先校验解绑原因
      const reason = this.unbindReason.trim();
      if (!reason) {
        Toast('请输入解绑原因');
        done(false); // 明确告诉弹窗：不关闭
        return;
      }

      try {
        // 3. 校验通过：二次确认
        await Dialog.confirm({
          title: '确认解绑',
          message: `确认解绑球杆【${this.currentClub.value}】吗？`,
          closeOnClickOverlay: false
        });

        // 4. 调用解绑接口
        const formData = {
          keyWord: this.currentClub.value,
          opinion: reason
        };
        await userUnbindByNumber(formData);

        // 5. 操作成功：关闭弹窗 + 刷新列表
        Toast.success(`球杆【${this.currentClub.value}】解绑成功`);
        done(); // 关闭弹窗
        this.selectProductByUser();

      } catch (error) {
        // 6. 处理取消/接口错误：不关闭弹窗
        done(false); // 明确告诉弹窗：不关闭
        if (error.type !== 'cancel') {
          Toast.fail('解绑失败，请稍后重试');
          console.error('解绑失败：', error);
        }
      }
    },

    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },

    // 获取球杆列表
    selectProductByUser() {
      benefitsByUser().then(res => {
        if (res.code === 200 && res.data) {
          this.clubList = res.data;
        } else {
          if(res.returnMsg && res.returnMsg =='您当前还没有球杆'){
            this.clubList = [];
          }
          Dialog.alert({
            title: '提示',
            message: res.returnMsg || '获取数据失败',
            style: {width: '90%', maxWidth: 'none'}
          });
        }
      }).catch(err => {
        Dialog.alert({
          title: '错误',
          message: '请稍后重试',
          style: {width: '90%', maxWidth: 'none'}
        });
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .van-card__content {
  @media (min-width: 768px) {
    min-height: 0;
  }
}

// 容器样式
.h5-container {
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #000;
  padding-bottom: 40px;

  @media (min-width: 768px) {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    padding-bottom: 60px;
  }
}

// 导航栏样式
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;

  @media (min-width: 768px) {
    font-size: 24px;
  }
}

::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;

  @media (min-width: 768px) {
    font-size: 18px;
  }
}

::v-deep .van-nav-bar__title {
  @media (min-width: 768px) {
    font-size: 22px;
    font-weight: bold;
  }
}

.top-bar {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);

  @media (min-width: 768px) {
    height: 70px;
    line-height: 70px;
  }
}

// 主容器
.container-item {
  margin-bottom: 60px;
  padding: 0 16px;
  box-sizing: border-box;
  width: 100%;

  @media (min-width: 768px) {
    margin-bottom: 80px;
    padding: 0 20px;
  }
}

// 卡片样式
.my-card {
  margin: 15px;
  border-radius: 12px;
  background: #fff;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (min-width: 768px) {
    margin: 20px auto;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    max-width: 100%;
  }

  ::v-deep .van-card__desc {
    padding: 0 !important;

    @media (min-width: 768px) {
      padding: 10px 0 !important;
    }
  }
}

// 信息项样式
.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 15px;
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }

  .label {
    color: #0f0f0f;
    width: 80px;
    font-weight: 500;
  }

  .value {
    color: #0f0f0f;
    word-break: break-all;
  }

  @media (min-width: 768px) {
    margin-bottom: 18px;
    font-size: 18px;

    .label {
      width: 100px;
      font-size: 18px;
      font-weight: bold;
    }

    .value {
      font-size: 18px;
      line-height: 1.6;
    }
  }
}

// 序列号行
.serial-item {
  justify-content: space-between;
  flex-wrap: nowrap;

  @media (min-width: 768px) {
    align-items: center;
    min-height: 40px;
  }
}

.label-value-wrap {
  display: flex;
  align-items: center;
  flex-shrink: 1;

  @media (min-width: 768px) {
    max-width: calc(100% - 120px);
  }
}

// 操作标签
.bind-tag {
  font-size: 14px;
  line-height: 20px;
  padding: 2px 6px;
  margin-left: 10px;
  flex-shrink: 0;
  cursor: pointer;

  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 24px;
    padding: 4px 12px;
    margin-left: 15px;
    border-radius: 6px;

    &:hover {
      background: #B8860B !important;
      color: #000 !important;
      transform: scale(1.05);
      transition: all 0.2s ease;
    }
  }
}

// 状态标签-红色
.bind-tag-red {
  font-size: 10px;
  line-height: 15px;
  padding: 2px 6px;
  margin-left: 10px;
  flex-shrink: 0;
  background: #FFFFFF;
  color: red;
  border: 1px solid red;
  border-radius: 15px;

  @media (min-width: 768px) {
    font-size: 14px;
    line-height: 20px;
    padding: 4px 10px;
    margin-left: 15px;
    border-radius: 20px;
    border-width: 2px;
  }
}

// 状态标签-绿色
.bind-tag-green {
  font-size: 10px;
  line-height: 15px;
  padding: 2px 6px;
  margin-left: 10px;
  flex-shrink: 0;
  background: #FFFFFF;
  color: green;
  border: 1px solid green;
  border-radius: 15px;

  @media (min-width: 768px) {
    font-size: 14px;
    line-height: 20px;
    padding: 4px 10px;
    margin-left: 15px;
    border-radius: 20px;
    border-width: 2px;
  }
}

// 添加按钮样式
.add-club-btn-wrapper {
  margin: 15px 15px 15px;
  text-align: center;

  @media (min-width: 768px) {
    margin: 40px 20px 20px;
  }
}

.add-club-btn {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
  border-radius: 12px;
  font-size: 16px;
  height: 48px;
  line-height: 48px;
  width: 100%;

  @media (min-width: 768px) {
    font-size: 18px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    max-width: 500px;
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.02);
      box-shadow: 0 4px 16px rgba(212, 175, 55, 0.4);
    }
  }

  ::v-deep &.van-button--primary {
    background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%) !important;
  }
}

// 解绑弹窗整体样式优化
::v-deep .unbind-dialog {
  // 移动端默认样式
  .van-dialog__content {
    padding: 20px;
  }

  // PC端弹窗适配
  @media (min-width: 768px) {
    width: 600px !important;
    max-width: 600px;

    // 弹窗标题样式 - 减小header高度
    .van-dialog__header {
      padding: 12px 20px 8px;  // 大幅减小上下内边距
      border-bottom: 1px solid #f5f5f5;
      height: auto;            // 取消固定高度，自适应内容

      .van-dialog__title {
        font-size: 18px;       // 标题字号也适当减小
        font-weight: bold;
        color: #333;
        line-height: 1.2;      // 行高优化
      }
    }

    // 弹窗内容区域
    .van-dialog__content {
      padding: 16px 20px;     // 减小内边距
      min-height: auto;        // 取消最小高度限制
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    // 弹窗按钮区域
    .van-dialog__footer {
      padding: 12px 20px 16px;// 减小内边距
      border-top: 1px solid #f5f5f5;

      .van-button {
        height: 40px;          // 按钮高度也适当减小
        padding: 0 24px;
        font-size: 16px;
        border-radius: 8px;
      }
    }
  }
}

// 解绑弹窗信息区域样式
.unbind-info-wrap {
  margin-bottom: 16px;       // 减小底部间距
  padding-bottom: 12px;      // 减小底部内边距
  border-bottom: 1px solid #eee;

  .unbind-info-item {
    display: flex;
    margin-bottom: 10px;      // 减小项间距
    font-size: 15px;
    align-items: center;

    .unbind-label {
      color: #666;
      min-width: 80px;
      font-weight: 500;
    }

    .unbind-value {
      color: #333;
      flex: 1;
      word-break: break-all;
      font-weight: 500;
    }

    // PC端信息项样式
    @media (min-width: 768px) {
      margin-bottom: 12px;
      font-size: 16px;

      .unbind-label {
        min-width: 90px;
        font-size: 16px;
        color: #555;
      }

      .unbind-value {
        font-size: 16px;
        color: #222;
      }
    }
  }
}

// 解绑原因输入框样式
.unbind-reason-field {
  // 移动端样式
  ::v-deep .van-field__label {
    font-size: 15px;
    color: #666;
    width: 80px;
  }

  ::v-deep .van-field__control {
    font-size: 15px;
    min-height: auto;        // 移动端也取消最小高度
  }

  // PC端输入框样式 - 移除高度限制
  @media (min-width: 768px) {
    ::v-deep .van-field__label {
      font-size: 16px;
      width: 90px;
      color: #555;
      font-weight: 500;
    }

    ::v-deep .van-field__control {
      font-size: 16px;
      min-height: auto;      // 移除最小高度限制，高度自适应内容
      max-height: none;      // 取消最大高度限制
      padding: 8px 12px;     // 减小内边距
      border-radius: 6px;
      border: 1px solid #e5e5e5;
    }

    ::v-deep .van-field__placeholder {
      font-size: 15px;
      color: #999;
    }
  }
}

// PC端弹窗优化补充
@media (min-width: 768px) {
  ::v-deep .van-dialog {
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }
}
</style>